import { createSelector } from 'reselect';
import { get, identity } from 'lodash/fp';

const populationDatasetErrorSelector = createSelector(
  get(['custom', 'population', 'error']),
  identity,
);

export default populationDatasetErrorSelector;
